export default __webpack_public_path__ + "static/media/agriculture.b054bf12.jpg";